import React from 'react'
import { cx } from 'class-variance-authority'
import { twMerge } from 'tailwind-merge'

type ImageAwsProps = {
  className?: string
  src?: string
  alt?: string
  imgSize?: number
  thumbnail?: boolean
  priority?: boolean
  label?: string
  square?: boolean
}

export const AWSImage: React.FC<ImageAwsProps> = ({
  className,
  src = '/img/default.svg',
  alt = 'Ressource réemploi',
  imgSize = 250,
  thumbnail,
  square = true,
  label,
}) => {
  const isSvg = src.includes('.svg')
  const isExternal = src.includes('https')

  const getImageSrc = () => {
    if (!isSvg) {
      if (isExternal) {
        const url = new URL(src)
        const params = new URLSearchParams(url.search)
        const isBraderie = src.includes('braderieducarrelage.fr')

        if (thumbnail) {
          if (isBraderie) {
            return src.replace('-large_default', '-home_default')
          } else {
            params.set('width', imgSize.toString())
            params.set('height', imgSize.toString())
          }
        } else {
          if (isBraderie) {
            return src.replace('-large_default', '-medium_default')
          } else {
            params.set('width', '750')
            params.delete('height')
          }
        }

        url.search = params.toString()
        return url.toString()
      } else {
        const imagePath = thumbnail ? `thumbnail/${src}` : src
        return `${process.env.NEXT_PUBLIC_ASSETS_PATH}/${imagePath}`
      }
    } else return `${process.env.NEXT_PUBLIC_ASSETS_PATH}/${src}`
  }

  const defaultImage = `${process.env.NEXT_PUBLIC_ASSETS_PATH}/img/default.svg`
  let errorCount = 0

  const onError = (e: React.SyntheticEvent<HTMLImageElement, Event>) => {
    const target = e.target as HTMLImageElement
    if (errorCount > 0 || target.src === defaultImage) return
    errorCount++
    target.src = defaultImage
    target.classList.remove('object-cover')
    target.classList.add('object-contain')
    if (thumbnail) target.classList.add('p-2')
    else target.classList.add('p-10')
  }

  return (
    <div className='w-full relative'>
      <img
        src={getImageSrc()}
        alt={alt}
        className={twMerge(
          cx(
            'rounded-sm w-full',
            {
              'aspect-square': square,
              'object-cover': !isSvg,
              'object-contain': isSvg,
              'p-10': isSvg && !thumbnail,
              'p-2': isSvg && thumbnail,
            },
            className,
          ),
        )}
        onError={onError}
        width={imgSize}
        height={imgSize}
      />
      {label && (
        <span className='absolute !bottom-1 !left-1 min-w-[50px] text-center rounded-sm bg-slate-700 opacity-75 px-2 py-1 text-sm text-white w-fit h-fit'>
          {label}
        </span>
      )}
    </div>
  )
}
